<template>
  <div class="audience-previews-panel">
    <div class="panel-header">
      <span class="panel-title">受众信息</span>
    </div>
    <draw-gauge :users="usersCount"></draw-gauge>
    <div class="savePeople">
      <div class="peopleItem">
        <span>地区：</span>
        <div>{{ statusData?.sentenceLines?.geo_locations || '' }}</div>
      </div>
      <div class="peopleItem">
        <span>语言：</span>
        <div>{{ statusData?.sentenceLines?.locales || '' }}</div>
      </div>
      <div class="peopleItem">
        <span>兴趣：</span>
        <div>{{ statusData?.sentenceLines?.flexible_spec || '' }}</div>
      </div>
      <div class="peopleItem">
        <span>性别：</span>
        <div>{{ statusData?.sentenceLines?.genders || '' }}</div>
      </div>
      <div class="peopleItem">
        <span>年龄组：</span>
        <div>{{ statusData?.sentenceLines?.age_range || '' }}</div>
      </div>
      <div
        class="btn"
        v-if="!edit"
      >
        <el-button
          size="mini"
          @click="savePeopleShow = true"
          >保存受众</el-button
        >
      </div>
    </div>
    <!-- 保存设置 -->
    <el-dialog
      title="保存受众"
      :visible.sync="savePeopleShow"
      width="600px"
    >
      <div>
        <el-form
          :model="ruleForm"
          ref="ruleForm"
          label-width="140px"
          class="demo-ruleForm"
        >
          <el-form-item
            label="名称："
            prop="name"
          >
            <el-input
              v-model="ruleForm.name"
              style="width: 200px"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="savePeopleShow = false">取 消</el-button>
        <el-button
          type="primary"
          @click="saveBtn"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { saveSavedContent } from '@/api/creatAd.js';
import DrawGauge from './targeting/DrawGauge';

export default {
  components: { DrawGauge },
  props: ['statusData', 'content', 'accountId', 'edit'],
  data() {
    return {
      savePeopleShow: false,
      ruleForm: {},
    };
  },
  computed: {
    usersCount() {
      return this.statusData ? this.statusData.estimate_mau || this.statusData.estimate_dau || 0 : 0;
    },
  },
  methods: {
    close() {
      this.$emit('close', 'freshCon');
    },
    saveBtn() {
      this.ruleForm.content = this.content;
      this.ruleForm.accountId = this.accountId;
      this.ruleForm.type = 'TARGETING';
      if (!this.ruleForm.name) {
        this.$message({
          type: 'warning',
          message: '请输入受众名称',
        });
      } else {
        saveSavedContent(this.ruleForm).then((res) => {
          if (res.code == 0) {
            this.$message({
              type: 'success',
              message: '保存成功',
            });
            this.savePeopleShow = false;
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.audience-previews-panel {
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  overflow: hidden;

  .panel-header {
    padding: 12px 16px;
    border-bottom: 1px solid #ebeef5;

    .panel-title {
      font-size: 14px;
      font-weight: 600;
      color: #303133;
    }
  }

  .savePeople {
    padding: 16px;
    font-size: 12px;

    .peopleItem {
      display: flex;
      align-items: flex-start;
      margin-bottom: 10px;

      &:last-of-type {
        margin-bottom: 0;
      }

      span {
        margin-right: 8px;
        color: #909399;
        flex: 50px 0 0;
      }

      div {
        flex: 1;
        color: #303133;
        word-break: break-all;
      }
    }

    .btn {
      text-align: center;
      margin-top: 16px;
    }
  }
}
</style>
